import * as React from "react";

function BookmarksIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20.283} height={19.932} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.283 19.932" {...props}>
      <g fillOpacity={1} fill="currentColor" fillRule="nonzero">
        <path d="M9.96 19.922c5.499 0 9.962-4.463 9.962-9.961S15.459 0 9.96 0 0 4.463 0 9.96c0 5.499 4.463 9.962 9.96 9.962Zm0-1.66c-4.589 0-8.3-3.711-8.3-8.301s3.711-8.3 8.3-8.3c4.59 0 8.302 3.71 8.302 8.3 0 4.59-3.711 8.3-8.301 8.3Z" />
        <path d="M7.06 15.137c.254 0 .4-.147.85-.586l1.992-1.963c.03-.03.069-.03.098 0l2.002 1.963c.44.44.586.586.84.586.322 0 .527-.235.527-.625V6.289c0-.947-.488-1.445-1.435-1.445H7.969c-.948 0-1.436.498-1.436 1.445v8.223c0 .39.205.625.528.625Z" />
      </g>
    </svg>
  );
}

export default BookmarksIcon;
